// extracted by mini-css-extract-plugin
module.exports = {"noCanvases":"no-canvases-empty-state_noCanvases__pTOXq"};